export enum Stage {
  LEAGUE = "League",
  PLAYOFF = "Playoff",
  FINAL = "Final",
}
